
    import {
        computed,
        defineComponent,
        unref,
    } from 'vue';
    import { DirectFlightFilter, BonusMilesFilter } from '@features/tourProduct/filterTourProducts';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import IsExclusiveFilter from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilter.vue';
    import useAdditionalFiltersHotel from '../common/useAdditionalFiltersHotel';

    export default defineComponent({
        name: 'AdditionalFiltersHotel',
        components: {
            Dropdown,
            IsExclusiveFilter,
            DirectFlightFilter,
            BonusMilesFilter,
        },
        setup(props, ctx) {
            const {
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                isExclusiveChanged,
                directFlightChanged,
                bonusMilesChanged,
                isExclusiveSelected,
                directFlightSelected,
                bonusMilesSelected,
                directFlightFilterShow,
                isBonusMilesFilterVisible,
                additionalFiltersHidden,
                numOfSelected,
                selectedOperators,
            } = useAdditionalFiltersHotel(ctx);

            const isAdditionalFilterVisible = computed(() => unref(isExclusiveFilterShow) || unref(directFlightFilterShow) || unref(isBonusMilesFilterVisible));
            return {
                additionalFiltersHidden,
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                directFlightFilterShow,
                isExclusiveChanged,
                directFlightChanged,
                bonusMilesChanged,
                isExclusiveSelected,
                directFlightSelected,
                bonusMilesSelected,
                isAdditionalFilterVisible,
                isBonusMilesFilterVisible,
                numOfSelected,
                selectedOperators,
            };
        },
    });
